class DeliveryCountdown extends HTMLElement {
  connectedCallback() {
    clearInterval(this._interval);
    const [cutoffHour, cutoffMinute] = (this.dataset.cutoff || '15:00').split(':').map(Number);
    const blackoutDays = (this.dataset.blackoutDays || '')
      .split(',')
      .map((d) => d.trim())
      .filter(Boolean)
      .map(Number);
    const blackoutDates = (this.dataset.blackoutDates || '')
      .split(',')
      .map((d) => d.trim())
      .filter(Boolean);

    this.timerEl = this.querySelector('.product-delivery-countdown__timer');
    this.beforeEl = this.querySelector('.product-delivery-countdown__before');
    this.afterEl = this.querySelector('.product-delivery-countdown__after');

    this._interval = setInterval(
      () => this._tick(cutoffHour, cutoffMinute, blackoutDays, blackoutDates),
      1000
    );
    this._tick(cutoffHour, cutoffMinute, blackoutDays, blackoutDates);
  }

  disconnectedCallback() {
    clearInterval(this._interval);
    clearTimeout(this._midnightTimeout);
  }

  _tick(cutoffHour, cutoffMinute, blackoutDays, blackoutDates) {
    const now = new Date();
    const todayISO = now.toISOString().slice(0, 10);
    const dayOfWeek = now.getDay();

    const isBlackedOut =
      blackoutDays.includes(dayOfWeek) || blackoutDates.includes(todayISO);

    if (isBlackedOut) {
      this._showAfter();
      return;
    }

    const cutoffMs =
      new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, cutoffMinute, 0) - now;

    if (cutoffMs <= 0) {
      this._showAfter();
      return;
    }

    const totalSeconds = Math.floor(cutoffMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (n) => String(n).padStart(2, '0');
    this.timerEl.innerHTML = `<strong>${hours}h</strong> | <strong>${pad(minutes)}m</strong> | <strong>${pad(seconds)}s</strong>`;
    this.beforeEl.removeAttribute('hidden');
    this.afterEl.setAttribute('hidden', '');
  }

  _showAfter() {
    clearInterval(this._interval);
    if (!(this.dataset.headingAfter || '').trim()) {
      this.style.display = 'none';
      this._scheduleResetAtMidnight();
      return;
    }
    this.beforeEl.setAttribute('hidden', '');
    this.afterEl.removeAttribute('hidden');
  }

  _scheduleResetAtMidnight() {
    clearTimeout(this._midnightTimeout);
    const now = new Date();
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    this._midnightTimeout = setTimeout(() => {
      this.style.display = '';
      this.connectedCallback();
    }, midnight - now);
  }
}

if (!customElements.get('delivery-countdown')) {
  customElements.define('delivery-countdown', DeliveryCountdown);
}
